// extracted by mini-css-extract-plugin
export default {"rejectedSummaryContainer":"RejectedSummary_rejectedSummaryContainer__Jt2H4","pagerContainer":"RejectedSummary_pagerContainer__okM1W"};